export const SIZES: Array<number> = [5, 10, 25, 50, 100, 250];

export const ALL_RESULTS = 0;
